import { render, staticRenderFns } from "./amend-popwindow.vue?vue&type=template&id=feaf3e9c"
import script from "./amend-popwindow.vue?vue&type=script&lang=js"
export * from "./amend-popwindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports